import { Stack, Typography } from '@mui/material';
import PatientSampleLists from './PatientSampleLists';

const PatientSamples = () => (
  <Stack direction="column" spacing={2}>
    <Typography variant="subtitle1">Associated samples</Typography>
    <PatientSampleLists />
  </Stack>
);

export default PatientSamples;
